import { useTranslation } from "react-i18next";
import { Card, CardContent } from "@/shared/ui/card";
import type { CsStats } from "../../api/aiKefuService";
import { buildSummaryCards } from "./helpers";

export function SummaryCards({ stats }: { stats: CsStats | undefined }) {
  const { t } = useTranslation("customer-service");
  const cards = buildSummaryCards(stats, t);
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-8 gap-3">
      {cards.map((s, i) => (
        <Card
          key={s.labelKey}
          className="shadow-sm fx-hover-lift"
          style={{ animationDelay: `${i * 30}ms` }}
        >
          <CardContent className="p-4">
            <div className="flex items-center justify-between mb-2">
              <div className={`p-2 rounded-lg ${s.color}`}>
                <s.icon className="h-4 w-4" />
              </div>
            </div>
            <p className="text-2xl font-bold text-foreground">{s.value}</p>
            <p className="text-2xs text-muted-foreground mt-1">{t(`summary.${s.labelKey}`)}</p>
            {s.hint && <p className="text-2xs text-muted-foreground/70 mt-0.5">{s.hint}</p>}
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
